import BsDateCalendar from './index.vue'
export default BsDateCalendar